import { NgModule, CUSTOM_ELEMENTS_SCHEMA }           from '@angular/core';
import { RegisterPracticeModule } from '../../health/routes/home/register-practice/register-practice.module';
import { SharedModule }       from '../../shared/shared.module';
import { PracticesComponent } from './practices/practices.component';
import { LocationsComponent } from './locations/locations.component'
import { ContactComponent } from './contacts/contact.component'
import {PracticesService}       from '../../services/practices.service';
import {PracticeComponent} from './practices/practice.component';
import {NewPracticeComponent} from './practices/new-practice.component';
import {LocationComponent} from './locations/location.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { ContactsComponent } from './contacts/contacts.component'
import {Globals} from '../../globals'
import { AttachmentService } from '../../services/attachments.service'
import { WizardComponent } from './wizard/wizard.component';
import { ServiceComponent } from './service/service.component'
import { ServicesComponent } from './service/services.component'
import { DoctorFormComponent } from './doctors/doctor-form.component'
import { ReadMoreComponent} from '../readmore/readmore.component'
import { GoogleMapsModule } from '@angular/google-maps'

// import { SelectModule } from "ng2-select";
import { DoctorsListingComponent } from './doctors/doctors_listing/doctors-listing.component';
import { DoctorProfileDetailComponent } from './doctors/doctor_profile/doctor-profile-detail.component';
import { PracticeHeaderComponent } from './practices/practice-header/practice-header.component';
import { ConfirmationComponent } from './practices/confirmation/confirmation.component';
import { RegisteredPracticesComponent } from './registered-practices/registered-practices.component';
import { RegisteredPracticesService } from '../../services/registered-practices.service';
import { CalendarsListingComponent } from './calendar/calendars-listing/calendars-listing.component';
import { CalendarFormComponent } from './calendar/calendar-form/calendar-form.component'
// import { NguiDatetimePickerModule } from '@ngui/datetime-picker';
import { GroupComponent } from './group/group.component';
import { EnterpriseComponent } from './enterprise/enterprise.component';
import { AllDoctorsComponent } from './all-doctors/all-doctors.component';
import { DoctorsFilterComponent } from './all-doctors/doctors-filter/doctors-filter.component';
import { IndexComponent } from './all-doctors/index/index.component';
import {ValidationService} from '../../services/validation.service';
import { BlockCalendarsComponent } from './block-calendars/block-calendars.component';
import { BlockCalendarFormComponent } from './block-calendars/block-calendar-form/block-calendar-form.component';
import {BlockCalendarService} from '../../services/block-calendar.service';
import {VisitsService} from '../../services/visits.service';
import {HttpClientModule} from '@angular/common/http';
import { ModalModule} from 'ngx-bootstrap/modal';
import { PracticeSettingsComponent } from './practice-settings/practice-settings.component';
import { ColorPickerModule } from 'ngx-color-picker';
import {NgxMaskModule} from 'ngx-mask'
import {IntegrationModule} from '../../integration/integration.module';
import {NgSelectModule} from '@ng-select/ng-select';
import { BillingComponent } from './billing/billing.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { InvoicePrintComponent } from './billing/invoice-print/invoice-print.component';
import {ContactUsService} from '../../public-content-pages/contact-us/contact-us.service';
import {EditorModule} from '@tinymce/tinymce-angular';
import { AmenityComponent } from './amenity/amenity.component';
import { AmenityIndexComponent } from './amenity/amenity-index/amenity-index.component';
import { NewAmenityComponent } from './amenity/new-amenity/new-amenity.component';
import { ViewAmenityComponent } from './amenity/view-amenity/view-amenity.component';
import {MultiselectDropdownModule} from 'angular-2-dropdown-multiselect';
import { AmenityAssociateComponent } from './amenity/amenity-associate/amenity-associate.component';
import {AdminLoginService} from '../../services/admin_login_service';
import { SessionWarningSettingsComponent } from './session-warning-settings/session-warning-settings.component';

@NgModule({
    imports:
        [ColorPickerModule, NgxMaskModule.forRoot(), IntegrationModule, GoogleMapsModule,
            ModalModule.forRoot(), HttpClientModule, SharedModule, FormsModule, ReactiveFormsModule, NgSelectModule, BsDatepickerModule, EditorModule, MultiselectDropdownModule,
            RegisterPracticeModule,
        ],
  entryComponents: [NewAmenityComponent, ViewAmenityComponent, WizardComponent, GroupComponent, EnterpriseComponent, DoctorFormComponent, DoctorProfileDetailComponent],
  exports: [AmenityComponent, DoctorProfileDetailComponent, ReadMoreComponent, ServicesComponent, LocationComponent, LocationsComponent, ContactComponent, WizardComponent, DoctorFormComponent, RegisteredPracticesComponent, CalendarsListingComponent, CalendarFormComponent],
  declarations: [DoctorProfileDetailComponent, DoctorsListingComponent, ReadMoreComponent, PracticeComponent, NewPracticeComponent, PracticesComponent, LocationComponent, LocationsComponent, ContactComponent, ContactsComponent, WizardComponent, ServiceComponent, DoctorFormComponent, ServicesComponent, PracticeHeaderComponent, ConfirmationComponent, RegisteredPracticesComponent, CalendarsListingComponent, CalendarFormComponent, GroupComponent, EnterpriseComponent, AllDoctorsComponent, DoctorsFilterComponent, IndexComponent, BlockCalendarsComponent, BlockCalendarFormComponent, PracticeSettingsComponent, BillingComponent, InvoiceComponent, InvoicePrintComponent, AmenityComponent, AmenityIndexComponent, NewAmenityComponent, ViewAmenityComponent, AmenityAssociateComponent, SessionWarningSettingsComponent],
  providers:    [VisitsService, ContactUsService, BlockCalendarService, ValidationService, RegisteredPracticesService, PracticesService, AttachmentService, Globals ], schemas:  [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class PracticesModule { }


/*
Copyright 2016 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/
